// src/contexts/AuthContext.js
import React, { createContext, useReducer, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { fetchUserDetails } from '../services/UserService';

export const AuthContext = createContext();

const initialState = {
  isAuthenticated: false,
  user: null,
  isLoading: true,
};

const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        isLoading: false,
      };
    case 'LOGOUT':
      return { ...initialState, isLoading: false };
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };
    default:
      return state;
  }
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  const logout = useCallback(() => {
    localStorage.removeItem('IdToken');
    localStorage.removeItem('RefreshToken');
    localStorage.removeItem('AccessToken');
    dispatch({ type: 'LOGOUT' });
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('IdToken');
      if (token) {
        try {
          const user = await fetchUserDetails(token);
          dispatch({ type: 'LOGIN', payload: user });
        } catch (error) {
          console.error('Error fetching user details:', error);
          dispatch({ type: 'SET_LOADING', payload: false });
        }
      } else {
        dispatch({ type: 'SET_LOADING', payload: false });
      }
    };

    fetchUser();
  }, []);

  const login = useCallback((user) => {
    dispatch({ type: 'LOGIN', payload: user });
  }, []);

  return (
    <AuthContext.Provider value={{ ...state, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
